<!-- <div [class.loader-hidden]="false"> -->
<div *ngIf="show" class="mainSpinner">
    <div class="loader-overlay">
        <div>
            <mat-progress-bar title="Prgress" mode="indeterminate" *ngIf="true"></mat-progress-bar>
        </div>
    </div>
</div>